import { Module } from 'vuex'
import { state } from './state'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { RootState } from 'store'
import { SettingState } from './types'

export const setting: Module<SettingState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}